// extracted by mini-css-extract-plugin
export default {"container":"AuthLayout_container__aAupX","formContainer":"AuthLayout_formContainer__OMZjC","input":"AuthLayout_input__9wW2d"};